import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { BOOLEAN_TYPES, DEFAULT_PAGE } from '../constants'

const TaskIsVerifiedFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { isVerified } = getQueryParams(search)

  const handleChange = useCallback(
    isVerified =>
      history.push(
        createUrl(pathname, search, {
          isVerified,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Verified">
      <Select
        style={{ width: '100%' }}
        value={isVerified?.toString()}
        onChange={handleChange}
        allowClear
      >
        {map(BOOLEAN_TYPES, ({ name, value }) => (
          <Select.Option key={value} value={value?.toString()}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default TaskIsVerifiedFilter
